export enum InvoiceIssueLogType {
    Override = 1,
    Cancel = 2,
}